import { SET_LIST_CORPATATE_USERS } from "../../reducerTypes"

const initialState = {
  getList: []
}

const corporateUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LIST_CORPATATE_USERS:
      return{
        ...state,
        getList: action.payload
      }
    default:
      return state
  }
}

export default corporateUserReducer
